import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'GifFooter',
  emits: ["back", "reset"],
  setup(__props, { emit: emits }: { emit: ({
  (e: "back"): void;
  (e: "reset"): void;
}), expose: any, slots: any, attrs: any }) {



return { __sfc: true,emits }
}

})